import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import ReactQuill from "react-quill";
import { useNavigate } from "react-router-dom";

const AllInternationalScholarship = () => {
  const [internationalScholarship, setInternationalScholarship] = useState([]);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const fetchScholarships = () => {
    axios
      .get(`${API_BASE_URL}/scholarships?type=International`)
      .then((result) => {
        setInternationalScholarship(result?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    fetchScholarships();
  }, []);

  const handleEdit=(id)=>{
    navigate(`/student-scholarship/edit-international-scholarship/${id}`);
  }
  const handleDelete = (id) => {
    if (window.confirm("Are you sure want to delete this scholarship?")) {
      axios
        .delete(`${API_BASE_URL}/scholarships/${id}`)
        .then((result) => {
          console.log(result);
          alert("Scholarship deleted successfully !!");
          fetchScholarships();
        })
        .catch((error) => {
          console.log("Failed to delete the scholarship", error);
          alert("An error occurred while deleting the scholarship");
        });
    }
  };
  return (
    <>
      <div id="all-central-gov-scholarship-all-main">
        <div className="all-central-gov-heading-main-div">
          <h4>International Scholarship Table</h4>
          <div className="header-main-btns">
            <button
              onClick={() =>
                navigate("/student-scholarship/international-scholarship")
              }
            >
              International Scholarship
            </button>
            <button>All International Scholarship</button>
          </div>
        </div>

        <div className="form-sub-container mt-4" id="form">
          <table className="classes-table">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Title</th>
                <th>Description</th>
                <th>YouTube Link</th>
                <th>Other Link</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {internationalScholarship &&
                internationalScholarship.map((item, idx) => (
                  <tr key={item._id}>
                    <td>{idx + 1}</td>
                    <td>{item.title}</td>
                    <td>{item.description.slice(0, 50)}...</td>
                    <td>{item.youtubeLink}</td>
                    <td>{item.officialLink}</td>
                    <td>
                      <span>
                        <FaEdit
                         onClick={() => handleEdit(item._id)}
                        />
                      </span>
                      <span>
                        <MdDelete onClick={() => handleDelete(item._id)} />
                      </span>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default AllInternationalScholarship;
